










































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import ChatModel from "@/models/Chat";
import { getModule } from "vuex-module-decorators";
import { store, UserModule } from "@/store";

import ChatMessage, { AlinhamentoMensagem } from "@/components/Chat/Mensagem.vue";
import ChatComponent, { MensagemChat } from "@/components/Chat/Chat.vue";
import EventBus, { DeclaredEvents, SnackPriorityToColor } from "@/EventBus";
import SingleChatController, { MensagemChatDados, MensagemChatDb, MensagemListener } from "@/components/Chat/SingleChatController";
import _debug from "debug";

const debug = _debug("Mediacao:views:processo:ChatView.vue");

const userModule = getModule(UserModule, store);

@Component({
    components: { chatMessage: ChatMessage, chatComponent: ChatComponent },
})
export default class ChatView extends Vue {
    @Prop() public carregando!: boolean;
    @Prop() public chats!: ChatModel[];
    @Prop() public podeAdicionar!: boolean;
    @Prop() public podeVisualizar!: boolean;
    @Prop() public poderApagar!: boolean;
    @Prop({ default: "chats" }) public titulo!: string;
    @Prop({ default: true }) public mostraTopo!: boolean;
    private mensagensPrincipal: MensagemChat[] = [];
    private mensagensParteUm: MensagemChat[] = [];
    private mensagensParteDois: MensagemChat[] = [];
    private chatController: SingleChatController | null = null;
    private loading = true;
    private isMediador = false;
    private parteId = "";
    private localMensagensEsperandoConfirmacaoServer: Map<number, MensagemChat> = new Map();
    private chatEncerrado = false;

    private alinhamentoMeio: AlinhamentoMensagem = AlinhamentoMensagem.meio;
    private rotaProcesso = "";
    private myMensagemListener: MensagemListener = {
        id: Math.random() * 100000000,
        novaMensagem: this.novaMensagem,
        mensagemAlterada: this.mensagemAlterada,
        mensagemRemovida: this.mensagemRemovida,
    };

    public novaMensagem(mensagem: MensagemChatDados) {
        this.loading = false;
        let alinhamento = AlinhamentoMensagem.direita;
        if (mensagem.tipoUsuario !== "mediador") {
            alinhamento = AlinhamentoMensagem.esquerda;
        }
        debug("ChatView.novaMensagem", mensagem);
        const mensagemChat: MensagemChat = Object.assign({}, mensagem, { alinhamento });
        switch (mensagem.tipoChat) {
            case "ParteUm":
                this.mensagensParteUm.push(mensagemChat);
                break;
            case "ParteDois":
                this.mensagensParteDois.push(mensagemChat);
                break;

            case "Principal":
                if (mensagemChat.tipoUsuario === "parteUm") {
                    mensagemChat.alinhamento = AlinhamentoMensagem.esquerda;
                } else if (mensagemChat.tipoUsuario === "parteDois") {
                    mensagemChat.alinhamento = AlinhamentoMensagem.direita;
                } else {
                    mensagemChat.alinhamento = AlinhamentoMensagem.meio;
                }
                this.mensagensPrincipal.push(mensagemChat);
                break;

            default:
                break;
        }
    }

    private mensagemAlterada(mensagem: MensagemChatDados) {
        debug("ChatView.mensagemAlterada", mensagem);
        let mensagemArray = this.mensagensPrincipal;
        switch (mensagem.tipoChat) {
            case "ParteUm":
                mensagemArray = this.mensagensParteUm;
                break;
            case "ParteDois":
                mensagemArray = this.mensagensParteDois;
                break;
            default:
                break;
        }
        let alinhamento = AlinhamentoMensagem.direita;
        const index = mensagemArray.findIndex(element => {
            alinhamento = element.alinhamento;
            return element.id === mensagem.id;
        });
        const mensagemChat: MensagemChat = Object.assign({}, mensagem, { alinhamento });
        mensagemArray.splice(index, 1, mensagemChat);
    }

    private mensagemRemovida(id: string) {
        debug("ChatView.mensagemRemovida", id);
        const mensagemArrays = [this.mensagensPrincipal, this.mensagensParteUm, this.mensagensParteDois];

        mensagemArrays.forEach(mensagemArray => {
            const index = mensagemArray.findIndex(element => {
                return element.id === id;
            });
            mensagemArray.splice(index, 1);
        });
    }

    private get isLoading() {
        return this.loading;
    }

    private get mensagensParte(): MensagemChat[] {
        console.log("ChatView.mensagensParte parteId", this.parteId);
        if (this.parteId === "ParteUm") {
            return this.mensagensParteUm;
        } else {
            return this.mensagensParteDois;
        }
    }

    private sortMensagens(mensagens: MensagemChat[]): MensagemChat[] {
        return mensagens.sort((a: MensagemChat, b: MensagemChat) => {
            if (a && a.sortId && b && b.sortId) {
                return a.sortId > b.sortId ? 1 : -1;
            }
            return 0;
        });
    }

    private async created() {
        debug("ChatView.created: id", this.$route.params);
        console.log("ChatView.created: id", this.$route.params);
        setTimeout(() => {
            this.loading = false;
        }, 2000);
        EventBus.$on(DeclaredEvents.singleChatControllerDisponivel, (chatController: SingleChatController) => {
            if (this.$route.params.idChat === chatController.chat.id) {
                debug("recebi o meu chat controller", chatController);
                this.inicializaChat(chatController);
            }
        });

        EventBus.$on(DeclaredEvents.chatEncerrado, (chat: ChatMessage) => {
            if (!this.isMediador) {
                EventBus.$emit(DeclaredEvents.snackBarMessage, {
                    message: "O Chat foi encerrado pelo Mediador",
                    priority: SnackPriorityToColor.success,
                });
            }
        });

        EventBus.$emit(DeclaredEvents.requestSingleChatController, {
            id: this.$route.params.idChat,
            callBack: (chatController: SingleChatController) => {
                debug("recebi o requested chat controller", chatController);
                this.inicializaChat(chatController);
            },
        });
    }
    private async inicializaChat(chatController: SingleChatController) {
        if (this.chatController && this.chatController.chat.id === chatController.chat.id) {
            debug("já tenho o chat controller");
            return;
        }
        this.chatController = chatController;
        debug("inicializaChat", chatController);
        if (chatController.chat.processo) {
            this.rotaProcesso = `/processo/${chatController.chat.processo.id}`;
            this.chatEncerrado = chatController.chat.status === "encerrado";
            const partes = await chatController.chat.processo.partesPromise;
            const user = userModule.getUser.userDb;
            if (partes && partes.mediador && user) {
                if (partes.mediador.email === user.email) {
                    this.isMediador = true;
                } else {
                    this.parteId = "ParteUm";
                    if (partes.parteDois && partes.parteDois.email === user.email) {
                        this.parteId = "ParteDois";
                    }
                }
            }
        }
        this.chatController.mensagensPreparadas.forEach((mensagem: MensagemChatDados) => {
            this.novaMensagem(mensagem);
        });
        chatController.addNovaMensagemListener(this.myMensagemListener);
    }

    private enviarMensagem(mensagem: any) {
        const user = userModule.getUser.userDb;
        if (this.chatController && user) {
            const novaMensagem: MensagemChatDb = {
                mensagem: mensagem.mensagem,
                dataHora: new Date(),
                tipoChat: mensagem.id,
                usuario: user.email,
            };
            this.chatController.enviarMensagem(novaMensagem);
        }
    }

    private enviarMensagemArquivo(mensagem: any) {
        const user = userModule.getUser.userDb;
        if (this.chatController && user && mensagem && mensagem.arquivos) {
            mensagem.arquivos.forEach((arquivo: File) => {
                const novaMensagem: MensagemChatDb = {
                    mensagem: "arquivo:" + arquivo.name,
                    dataHora: new Date(),
                    tipoChat: mensagem.id,
                    usuario: user.email,
                    url: "loading",
                    tipoArquivo: arquivo.type,
                };
                if (this.chatController) {
                    this.chatController.enviarMensagemArquivo(novaMensagem, arquivo);
                }
            });
        }
    }

    private async encerrarChat() {
        if (this.chatController) {
            await this.chatController.encerrarChat();
            EventBus.$emit(DeclaredEvents.chatEncerrado, this.chatController.chat);
            this.$router.push(this.rotaProcesso);
        }
    }
}
